import availableCities from './available-cities';
import template from './location-hero.html';
import './location-hero.global.css';

class LocationHeroController {
  get imageId() {
    return this._imageId || imageFromAddress(this.address);
  }

  set imageId(value) {
    this._imageId = value;
  }

  get imageUrlMobile() {
    return `t_location_hero_mobile/move-locations/${this.imageId}`;
  }

  get imageUrlWeb() {
    return `t_location_hero_web/move-locations/${this.imageId}`;
  }
}

export const LocationHeroComponent = {
  controller: LocationHeroController,
  bindings: {
    address: '<',
    imageId: '@',
    user: '<',
  },
  template,
};

function imageFromAddress(address) {
  const city = availableCities[address.city.toLowerCase()];
  const cityOrState = city || address.state.toLowerCase();
  return `move-location-${cityOrState}`;
}
